import React from 'react';
import './Modal.css';

const ZoneCardModal = ({ card, origin, onClose, onAction }) => {
  if (!card) return null;

  const isMonster = card.type?.includes('Monster');
  const isLink = card.type?.includes('Link');
  const isExtra= card.type?.includes('Link')||card.type?.includes('Synchro')||card.type?.includes('Fusion')||card.type?.includes('XYZ');
  const isSpellTrap = !isMonster;

  let actions = [];
    if (card.zone?.startsWith('Opp')) {
    actions = []; // No actions for opponent card
  }

 else if (origin === 'GY') {
    if (isMonster && !isExtra) {
        actions = [
        'To S/T', 'Target', 'To Bottom Deck', 'To Top Deck',
        'Banish FD', 'Banish', 'To Hand', 'Declare', 'SS DEF GY', 'SS ATK GY'
        ];
    } else if (isMonster && isLink) {
        actions = [
        'To S/T', 'Target', 
        'Banish FD', 'Banish', 'To Extra', 'Declare', 'SS ATK GY'
        ];
    }else if (isExtra && !isLink) {
        actions = [
        'To S/T', 'Target','Declare', 
        'Banish FD', 'Banish', 'To Extra', 'SS ATK GY', 'SS DEF GY'
        ];
    } else if (isSpellTrap) {
        actions = [
        'To S/T', 'Target', 'To Bottom Deck', 'To Top Deck',
        'Banish FD', 'Banish', 'To Hand', 'Declare'
        ];
    }
    } else if (origin === 'BZ') {
    if (isMonster && !isExtra) {
        actions = [
        'Target', 'To Bottom Deck', 'To Top Deck',
        'To Hand', 'Declare', 'To GY', 'SS DEF', 'SS ATK'
        ];
    } else if (isMonster && isLink) {
        actions = [
        'Target', 'Declare', 'To Extra', 'To GY', 'SS ATK'
        ];
        
    } 
    else if (isExtra && !isLink) {
        actions = [
         'Target','Declare', 'To Extra','To GY','SS ATK GY', 'SS DEF GY'
        ];
    }else if (isSpellTrap) {
        actions = [
        'Target', 'To Bottom Deck', 'To Top Deck',
        'To Hand', 'Declare', 'To GY'
        ];
    }
    } else if (origin === 'Deck') {
    if (isMonster) {
        actions = [
        'To S/T', 'Banish FD', 'Banish', 'To GY', 'To Hand', 'SS DEF', 'SS ATK'
        ];
    } else {
        actions = [
        'To S/T', 'Banish FD', 'Banish', 'To GY', 'To Hand'
        ];
    }
    }


  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content hand-menu-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-left">
          <img
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => e.button === 2 && e.preventDefault()}
            onTouchStart={(e) => e.preventDefault()}
            draggable={false}
            src={card.card_images?.[0]?.image_url}
            alt={card.name}
            className="modal-card-image"
          />
          <div className="modal-card-info">
            <h3>{card.name}</h3>
            <p><strong>Card:</strong> {card.type}</p>
            {card.atk !== undefined && (
              <p><strong>ATK/DEF:</strong> {card.atk} / {card.def ?? '—'}</p>
            )}
            {card.level && <p><strong>Level:</strong> {card.level}</p>}
            {card.linkval && <p><strong>Link Rating:</strong> {card.linkval}</p>}
            {card.race && <p><strong>Type:</strong> {card.race}</p>}
            {card.attribute && <p><strong>Attribute:</strong> {card.attribute}</p>}
            <p dangerouslySetInnerHTML={{ __html: card.desc?.replace(/\n/g, '<br/>') }} />
          </div>
        </div>

        <div className="modal-right">
          <h3>Choose Action</h3>
          <ul className="action-list">
            {actions.map((action, index) => (
              <li key={index} onClick={() => onAction(action)}>{action}</li>
            ))}
          </ul>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ZoneCardModal;
